var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3827 4.11428C14.1179 4.06139 13.9011 3.89598 13.7889 3.65892C12.5485 1.04157 9.67349 -0.422021 6.79995 0.107602C4.18184 0.587713 2.12937 2.6777 1.69164 5.30968C1.56186 6.08648 1.57161 6.86441 1.7179 7.62209C1.76591 7.86927 1.65938 8.14459 1.44108 8.34301C0.524746 9.17607 0 10.3628 0 11.5999C0 14.0259 1.97408 16.0008 4.40089 16.0008H13.2031C16.5124 16.0008 19.2044 13.3088 19.2044 9.99939C19.2044 7.14686 17.1767 4.67166 14.3827 4.11465V4.1139V4.11428ZM12.0995 9.36512C11.9435 9.52115 11.7387 9.59955 11.5339 9.59955C11.3291 9.59955 11.1243 9.52115 10.9683 9.36512L9.60222 7.99905V12.0001C9.60222 12.4427 9.24364 12.8002 8.80216 12.8002C8.36068 12.8002 8.0021 12.4423 8.0021 12.0001V7.99905L6.63603 9.36512C6.32321 9.67794 5.8176 9.67794 5.5044 9.36512C5.19158 9.0523 5.19158 8.54668 5.5044 8.23348L7.67052 6.06735C7.97922 5.75866 8.38506 5.60337 8.79091 5.60075L8.80216 5.5985L8.81341 5.60075C9.22001 5.603 9.62473 5.75828 9.9338 6.06735L12.0999 8.23348C12.4127 8.5463 12.4127 9.05192 12.0999 9.36512H12.0995Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargar);
export default __webpack_public_path__ + "static/media/cargar.be82d1c489fb4406b69c2a1a59af9617.svg";
export { ForwardRef as ReactComponent };